import seed from "../../../../agents/dummyaccount.json";

const KEY = "internal-accounts-v25";

const money = (value) => {
    if (value == null || value === "") return "";
    return `$${Number(value).toLocaleString("en-US")}`;
};

export const costLabel = (cost) => {
    if (!cost || cost.value == null) return "";
    if (cost.type === "copayPercent") return `${cost.value}%`;
    return money(cost.value);
};

export const costsLabel = (service) => {
    const parts = (service?.costs || []).map(costLabel).filter(Boolean);
    return parts.join(" · ");
};

export function loadAccounts() {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (raw) return JSON.parse(raw);
    } catch {
        // A bad session value falls through to the seed account.
    }
    const accounts = [{ id: "dummy-account", ...structuredClone(seed) }];
    sessionStorage.setItem(KEY, JSON.stringify(accounts));
    return accounts;
}

export function saveAccounts(accounts) {
    sessionStorage.setItem(KEY, JSON.stringify(accounts));
}

export function findAccount(id) {
    return loadAccounts().find((account) => account.id === id) || null;
}

export function planNames() {
    return (seed.benefitPlans || []).map((plan) => plan.planName);
}

const accountId = (name) => (
    String(name || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || `account-${Date.now()}`
);

const uniqueAccountId = (accounts, name) => {
    const base = accountId(name);
    return accounts.some((row) => row.id === base) ? `${base}-${accounts.length + 1}` : base;
};

export function addAccount() {
    const accounts = loadAccounts();
    const saved = {
        id: uniqueAccountId(accounts, ""),
        accountName: "",
        contacts: [],
        address: [],
        bankAccounts: [],
        subAccounts: [],
        benefitPlans: [],
        notes: [],
    };
    saveAccounts([saved, ...accounts]);
    return saved;
}

export function addAccountDocument(document) {
    const accountName = String(document?.accountName || "").trim() || "New account";
    const accounts = loadAccounts();
    const saved = {
        ...structuredClone(document || {}),
        id: uniqueAccountId(accounts, accountName),
        accountName,
        contacts: document?.contacts || [],
        address: document?.address || [],
        bankAccounts: document?.bankAccounts || [],
        subAccounts: document?.subAccounts || [],
        benefitPlans: document?.benefitPlans || [],
        notes: document?.notes || [],
    };
    saveAccounts([saved, ...accounts]);
    return saved;
}

export function deskFact(account, deskId) {
    const plans = (account.benefitPlans || []).map((plan) => plan.planName);
    const contact = account.contacts?.[0]?.name;
    const carrier = account.stoploss?.carrier;
    if (deskId === "underwriter") return carrier || "No stop-loss yet";
    if (deskId === "legal") return account.stoploss?.contractType || "Not signed";
    if (deskId === "client-success") return contact || "No contact yet";
    if (deskId === "admin") return `${plans.length} plans · ${account.subAccounts?.length || 0} sub-accounts`;
    if (deskId === "plan-config") return plans.length ? `${plans.length} to code` : "No plans";
    return plans.length ? plans.join(", ") : "No plans";
}

export function deskFactLabel(deskId) {
    if (deskId === "underwriter" || deskId === "legal") return "Stop-loss";
    if (deskId === "client-success") return "Contact";
    if (deskId === "admin") return "Record";
    if (deskId === "plan-config") return "Codes";
    return "Plans";
}

export { money };
